import ReactPlayer from 'react-player/youtube'

export default function FullPageVideo({ youtubeId }) {
  return (
    <div
      className='video'
      style={{
        position: 'relative',
        paddingBottom: '56.25%' /* 16:9 */,
        paddingTop: 25,
        height: 0
      }}>
      <ReactPlayer
        title='full page video'
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          zIndex: 1
        }}
        height='100%'
        width='100%'
        url={ `https://www.youtube.com/embed/${ youtubeId }` }
        config={{
          youtube: {
            playerVars: { 
              showinfo: 0,
              frameborder: 0,
              controls: 1,
              color: 'green',
              modestbranding: 1
            },
            embedOptions: {
              showinfo: 0,
              frameborder: 0,
              controls: 1,
              color: 'green',
              modestbranding: 1
            }
          }
        }}/>
    </div>
  )
}